<template>
  <div :id="componentId" class="sp1-host-section" :style="sectionStyle">
    <div class="host-list flex-row">
      <div
        v-for="(host, idx) in hosts"
        :key="idx"
        class="host-card flex-col justify-between"
      >
        <div class="host-image-wrapper flex-col">
          <img
            class="host-image"
            referrerpolicy="no-referrer"
            :src="host.image"
          />
          <div class="host-name-bar flex-col">
            <span class="host-name" v-html="host.name"></span>
          </div>
        </div>
        <div class="host-intro-bar flex-col">
          <span class="host-intro">{{ host.introduction }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'HostSection',
  props: {
    componentId: {
      type: String,
      default: 'sp_one_module_9'
    }
  },
  data() {
    return {
      backgroundColor: 'rgba(255, 255, 255, 1)',
      hosts: [
        {
          name: '范&nbsp;&nbsp;红',
          introduction: '2026中国区域农业品牌发展',
          image: require('../assets/img/FigmaDDSSlicePNG069168c115b2a926ff659c678ac25dcc.png')
        },
        {
          name: '范&nbsp;&nbsp;红',
          introduction: '2026中国区域农业品牌发展',
          image: require('../assets/img/FigmaDDSSlicePNG069168c115b2a926ff659c678ac25dcc.png')
        },
        {
          name: '范&nbsp;&nbsp;红',
          introduction: '2026中国区域农业品牌发展',
          image: require('../assets/img/FigmaDDSSlicePNG069168c115b2a926ff659c678ac25dcc.png')
        },
        {
          name: '范&nbsp;&nbsp;红',
          introduction: '2026中国区域农业品牌发展',
          image: require('../assets/img/FigmaDDSSlicePNG069168c115b2a926ff659c678ac25dcc.png')
        }
      ]
    };
  },
  computed: {
    sectionStyle() {
      return {
        backgroundColor: this.backgroundColor,
        width: '2000px',
        marginLeft: '-300px',
        padding: '20px 300px',
        boxSizing: 'border-box'
      };
    },
    titleGroupStyle() {
      return {
        margin: '0px auto 0',
        width: '360px',
        height: '70px',
        backgroundImage: `url(${this.titleBackgroundImage})`,
        backgroundRepeat: 'no-repeat',
        backgroundSize: '100% 100%',
        backgroundPosition: 'center',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
      };
    }
  }
};
</script>

<style scoped>
.sp1-host-section {
  width: 2000px;
  margin-left: -300px;
  padding: 0 300px;
  box-sizing: border-box;
  padding-top: 39px;
}

.sp1-group_69 .sp1-text_9 {
  margin: 0;
  width: auto;
  height: auto;
  text-align: center;
  line-height: 1;
}

.host-list {
  width: 1400px;
}

.host-card {
  width: 333px;
  height: 468px;
  margin-left: 20px;
}

.host-card:first-child {
  margin-left: 0;
}

.host-image-wrapper {
  position: relative;
  width: 333px;
  height: 408px;
}

.host-image {
  width: 333px;
  height: 408px;
}

.host-name-bar {
  position: absolute;
  left: 0;
  bottom: 0;
  width: 333px;
  height: 48px;
  background: url(../assets/img/FigmaDDSSlicePNG73297531bb1080ef078c4bbea576aa88.png)
    100% no-repeat;
  background-size: 100% 100%;
  justify-content: center;
}

.host-name {
  width: 68px;
  height: 30px;
  overflow-wrap: break-word;
  color: rgba(255, 255, 255, 1);
  font-size: 26px;
  font-family: Microsoft YaHei-Regular;
  text-align: left;
  white-space: nowrap;
  line-height: 30px;
  margin-left: 27px;
}

.host-intro-bar {
  box-shadow: 0px 1px 6px 2px rgba(52, 221, 199, 1);
  background-image: linear-gradient(
    90deg,
    rgba(43, 131, 120, 1) 0,
    rgba(25, 196, 174, 1) 100%
  );
  width: 333px;
  height: 60px;
  justify-content: center;
}

.host-intro {
  width: 281px;
  height: 30px;
  overflow-wrap: break-word;
  color: rgba(255, 255, 255, 1);
  font-size: 20px;
  letter-spacing: 1.1764706373214722px;
  font-family: Microsoft YaHei-Regular;
  text-align: left;
  white-space: nowrap;
  line-height: 30px;
  margin-left: 28px;
}
</style>
